<div class="modal-confirm">
  <div class="modal-confirm__header">
    <h2 class="modal-confirm__title body-header">
      {{ titleKey() | translate }}
    </h2>

    <button class="modal-confirm__button modal-confirm__close" type="button" (click)="onCancel()">
      <app-icon class="icon-close" [icon]="IconName.CLOSE" />
    </button>
  </div>

  <form class="modal-confirm__form" [formGroup]="roleForm" (ngSubmit)="onSave()">
    <div class="modal-confirm__input-wrapper">
      <label for="name" class="modal-confirm__label">
        {{ 'shop-settings.roles.rolesModal.name' | translate }}
      </label>

      <mat-form-field appearance="outline" class="modal-confirm__field">
        <input
          id="name"
          matInput
          required
          formControlName="name"
          [placeholder]="'shop-settings.roles.rolesModal.placeholders.name' | translate"
        />
      </mat-form-field>

      @if (nameControl?.touched && nameControl?.invalid) {
        <p class="modal-confirm__field-error">
          @if (nameControl?.hasError('required')) {
            {{ 'shop-settings.roles.rolesModal.errors.required' | translate }}
          } @else if (nameControl?.hasError('invalidRoleName')) {
            {{ 'shop-settings.roles.rolesModal.errors.invalidName' | translate }}
          } @else if (nameControl?.hasError('roleNameExists')) {
            {{ 'shop-settings.roles.rolesModal.errors.duplicateName' | translate }}
          }
        </p>
      }
    </div>

    <div class="modal-confirm__input-wrapper">
      <label for="description" class="modal-confirm__label">
        {{ 'shop-settings.roles.rolesModal.description' | translate }}
      </label>
      <mat-form-field
        appearance="outline"
        class="modal-confirm__field modal-confirm__field--description"
      >
        <textarea
          id="description"
          matInput
          formControlName="description"
          rows="3"
          class="modal-confirm__textarea"
          [placeholder]="'shop-settings.roles.rolesModal.placeholders.description' | translate"
        ></textarea>
      </mat-form-field>
      @if (descriptionControl?.touched && descriptionControl?.invalid) {
        <p class="modal-confirm__field-error">
          {{ 'shop-settings.roles.rolesModal.errors.invalidDescription' | translate }}
        </p>
      }
    </div>

    <p class="modal-confirm__toggle-wrapper modal-confirm__toggle-wrapper--alt">
      {{ 'shop-settings.roles.rolesModal.admin' | translate }}
      <mat-slide-toggle formControlName="admin" [hideIcon]="true" />
    </p>

    <div class="modal-confirm__permissions">
      <span class="modal-confirm__label modal-confirm__label--permissions">
        {{ 'shop-settings.roles.rolesModal.permission' | translate }}
      </span>

      @if (permissionsGroup.invalid && (permissionsGroup.touched || permissionsGroup.dirty)) {
        <p class="modal-confirm__permissions-error">
          {{ 'shop-settings.roles.rolesModal.errors.permissionsRequired' | translate }}
        </p>
      }

      <div formGroupName="permissions">
        @for (permission of permissionsConfig; track permission.controlName) {
          <p
            class="modal-confirm__toggle-wrapper"
            [ngClass]="{ 'modal-confirm__toggle-wrapper--alt': permission.isAlt }"
          >
            {{ permission.labelKey | translate }}
            <mat-slide-toggle [formControlName]="permission.controlName" [hideIcon]="true" />
          </p>
        }
      </div>
    </div>

    <div class="modal-confirm__btnWrapper">
      <button type="button" class="modal-confirm__button btn-white" (click)="onCancel()">
        {{ 'shop-settings.roles.rolesModal.cancel' | translate }}
      </button>

      <button type="submit" class="modal-confirm__button btn-primary">
        {{ translationKey() | translate }}
      </button>
    </div>
  </form>
</div>
